import { render } from "./VacancyButton.vue?vue&type=template&id=4c2da80f"
import script from "./VacancyButton.vue?vue&type=script&lang=js"
export * from "./VacancyButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__